import * as Styles from './styles'

const TEMPLATE_FILE_URL = 'https://assets.reveni.io/public/templates/returns_import_report.csv'

export const getSteps = t => [
  {
    title: t('Prepara tu archivo'),
    description: (
      <>
        <Styles.DownloadLink href={TEMPLATE_FILE_URL} download>
          {t('Descarga un fichero de base de ejemplo')}
        </Styles.DownloadLink>{' '}
        {t(
          'y complétalo con todos los detalles de cada solicitud que quieras crear, como el número de pedido, los productos a devolver, el método de devolución y el método de reembolso.'
        )}
      </>
    ),
  },
  {
    title: t('Súbelo'),
    description: t(
      'Selecciona tu archivo de validación actualizado en el campo de la parte inferior y súbelo para importar su contenido._create_rmas',
      {
        defaultValue:
          'Selecciona tu archivo de validación actualizado en el campo de la parte inferior y súbelo para importar su contenido.',
      }
    ),
  },
  {
    title: t('Revisa los resultados de la importación'),
    description: t(
      'Una vez completado el procesamiento, recibirás un correo electrónico con los resultados. Si se informa de algún error, actualiza tu archivo para corregirlos y súbelo de nuevo.'
    ),
  },
]
